"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 11.17.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.StargateDuplicateDtoToJSON = exports.StargateDuplicateDtoFromJSONTyped = exports.StargateDuplicateDtoFromJSON = exports.instanceOfStargateDuplicateDto = void 0;
var runtime_1 = require("../runtime");
var CompactEntity_1 = require("./CompactEntity");
/**
 * Check if a given object implements the StargateDuplicateDto interface.
 */
function instanceOfStargateDuplicateDto(value) {
    var isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "formattedId" in value;
    isInstance = isInstance && "firstName" in value;
    isInstance = isInstance && "lastName" in value;
    isInstance = isInstance && "dob" in value;
    isInstance = isInstance && "ethnicity" in value;
    isInstance = isInstance && "mrn" in value;
    isInstance = isInstance && "phone" in value;
    isInstance = isInstance && "address1" in value;
    isInstance = isInstance && "address2" in value;
    isInstance = isInstance && "city" in value;
    isInstance = isInstance && "state" in value;
    isInstance = isInstance && "country" in value;
    return isInstance;
}
exports.instanceOfStargateDuplicateDto = instanceOfStargateDuplicateDto;
function StargateDuplicateDtoFromJSON(json) {
    return StargateDuplicateDtoFromJSONTyped(json, false);
}
exports.StargateDuplicateDtoFromJSON = StargateDuplicateDtoFromJSON;
function StargateDuplicateDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'formattedId': json['formatted_id'],
        'firstName': json['first_name'],
        'lastName': json['last_name'],
        'middleInitial': !(0, runtime_1.exists)(json, 'middle_initial') ? undefined : json['middle_initial'],
        'gender': !(0, runtime_1.exists)(json, 'gender') ? undefined : json['gender'],
        'biologicalSex': !(0, runtime_1.exists)(json, 'biological_sex') ? undefined : json['biological_sex'],
        'dob': json['dob'],
        'ethnicity': json['ethnicity'],
        'mrn': json['mrn'],
        'deceased': !(0, runtime_1.exists)(json, 'deceased') ? undefined : json['deceased'],
        'deceasedDate': !(0, runtime_1.exists)(json, 'deceased_date') ? undefined : json['deceased_date'],
        'phone': json['phone'],
        'address1': json['address_1'],
        'address2': json['address_2'],
        'city': json['city'],
        'state': json['state'],
        'country': json['country'],
        'requisitions': !(0, runtime_1.exists)(json, 'requisitions') ? undefined : (json['requisitions'].map(CompactEntity_1.CompactEntityFromJSON)),
        'families': !(0, runtime_1.exists)(json, 'families') ? undefined : (json['families'].map(CompactEntity_1.CompactEntityFromJSON)),
        'activity': !(0, runtime_1.exists)(json, 'activity') ? undefined : json['activity'],
    };
}
exports.StargateDuplicateDtoFromJSONTyped = StargateDuplicateDtoFromJSONTyped;
function StargateDuplicateDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'formatted_id': value.formattedId,
        'first_name': value.firstName,
        'last_name': value.lastName,
        'middle_initial': value.middleInitial,
        'gender': value.gender,
        'biological_sex': value.biologicalSex,
        'dob': value.dob,
        'ethnicity': value.ethnicity,
        'mrn': value.mrn,
        'deceased': value.deceased,
        'deceased_date': value.deceasedDate,
        'phone': value.phone,
        'address_1': value.address1,
        'address_2': value.address2,
        'city': value.city,
        'state': value.state,
        'country': value.country,
        'requisitions': value.requisitions === undefined ? undefined : (value.requisitions.map(CompactEntity_1.CompactEntityToJSON)),
        'families': value.families === undefined ? undefined : (value.families.map(CompactEntity_1.CompactEntityToJSON)),
        'activity': value.activity,
    };
}
exports.StargateDuplicateDtoToJSON = StargateDuplicateDtoToJSON;
